import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import Header from '../../Header';
import Footer from '../../Footer';
import { useCart } from '../../CartProvider';
import Toast from '../../Toast';

const products = {
  1: { 
    id: 1,
    name: "Weight Management Capsules",
    category: "Weight Loss",
    price: 2199,
    originalPrice: 2858,
    rating: 4.8,
    reviews: 124,
    image: "/keto1.jpeg",
    gallery: [
      "/keto2.jpeg",
      "/keto3.jpeg"
    ],
    benefits: ["Metabolism Boost", "Natural Fat Burn", "Appetite Control"],
    description: "Powerful blend of natural herbs to support healthy weight management and boost metabolism",
    ingredients: ["Garcinia (Garcinia Gummi-Gutta) – 200 mg", "Green Tea (Camellia Sinensis) – 100 mg", "Green Coffee (Coffea Arabica / Coffea Canephora) – 100 mg", "Fenugreek (Trigonella Foenum Graecum) – 50 mg", "Guggul (Commiphora Mukul / Commiphoraspp) – 50 mg"],
    usage: "Take 2 capsules daily with meals or as directed by your healthcare practitioner.",
    size: "60 capsules (30-day supply)",
    inStock: true
  },
  2: {
    id: 2,
    name: "Joint Pain Relief Oil",
    category: "Joint Pain",
    price: 1599,
    originalPrice: 2079,
    rating: 4.9,
    reviews: 89,
    image: "/joint1.jpeg",
    gallery: [
      "/joint2.jpeg",
      "/joint3.jpeg"
    ],
    benefits: ["Reduces Pain", "Improves Mobility", "Natural Healing"],
    description: "This therapeutic oil blend combines traditional Ayurvedic herbs with modern extraction techniques to provide effective relief from joint pain and stiffness. Penetrates deep into tissues for lasting comfort.",
    ingredients: ["Nirgundi Oil (Vitex negundo) – 20 ml", "Nilgiri Oil (Eucalyptus globulus) – 6.6 ml", "Dhatura Oil (Datura stramonium) – 5 ml", "Erend Oil (Ricinus communis) – 5.5 ml", "Lemon Grass Oil (Cymbopogon citratus) – 5 ml", "Kalonji Oil (Nigella sativa) – 5 ml", "Kapur Oil (Cinnamomum camphora) – 10 ml", "Gandhapura Tail (Gaultheria fragrantissima) – 28 ml", "Gandhabiroja Tail (Pinus longifolia sap) – 5 ml", "Til Oil – 4.9 ml"],
    usage: "Massage gently into affected areas 2-3 times daily. For best results, apply after a warm bath.",
    size: "100ml bottle",
    inStock: true
  },
  3: {
    id: 3,
    name: "Weight Loss Tablets",
    category: "Weight Loss",
    price: 1999,
    originalPrice: 2599,
    rating: 4.7,
    reviews: 156,
    image: "/gain1.jpeg",
    gallery: [
      "/gain2.jpeg",
      "/gain3.jpeg"
    ],
    benefits: ["Reduces Stress", "Improves Sleep", "Boosts Energy"],
    description: "Our herbal supplement is crafted with a powerful blend of Shuddha Guggul, Triphala, Trikatu, Trimad, and Vrikshamla. This unique Ayurvedic formulation helps support healthy weight management, digestion, and metabolism, while naturally boosting energy and overall wellness.",
    ingredients: ["Shuddha Guggul (Commiphora mukul) – 280 mg", "Triphala Churna (Generic preparation) – 90 mg", "Trikatu Churna (Generic preparation) – 90 mg", "Trimad Churna (Generic preparation) – 90 mg", "Vrikshamla (Kadha) (Garcinia indica) – qs", "Bhavana Dravya – qs", "Excipient – qs"],
    usage: "Take 1-2 capsules daily with water, preferably with meals. For best results, take consistently for at least 4-6 weeks.",
    size: "60 capsules (30-60 day supply)",
    inStock: true
  },
  4: {
    id: 4,
    name: "Fit & Fine Slimming Oil",
    category: "Skin Care",
    price: 1599,
    originalPrice: 2079,
    rating: 4.8,
    reviews: 231,
    image: "/oil1.jpeg",
    gallery: [
      "/oil2.jpeg",
      "/oil2.jpeg"
    ],
    benefits: ["Faster Results", "Stimulates Circulation", "Body Toning", "Tones Skin"],
    description: "Fit & Fine Slimming Oil is a 100% natural Ayurvedic formulation crafted with a blend of powerful herbal oils like Brahmi, Amla, Turmeric, Lemon, and Pomegranate. This oil is designed to help reduce cellulite, stimulate blood circulation, tone the skin, and promote a firmer body shape. Regular massage helps improve fat metabolism and supports inch loss naturally.",
    ingredients: ["Brahmi (Bacopa monnieri) – 3%", "Amla (Phyllanthus emblica) – 3%", "Punarnava (Boerhaavia diffusa) – 2%", "Turmeric (Curcuma longa) – 5%", "Gomutra (Shuddha) – 2%", "Tea Tree (Melaleuca alternifolia) – 2%", "Pomegranate (Punica granatum) – 2%", "Lemon (Citrus limon) – 2%", "Erand (Ricinus communis) – 2%", "Ajwain (Trachyspermum ammi) – 2%", "Sesame (Sesamum indicum) – Q.S"],
    usage: "Massage daily on concerned areas like stomach, upper arms, and legs for 15–20 minutes. Cover with a hot towel for 10 minutes for best results.",
    size: "200 ml",
    inStock: true
  },
  5: { 
    id: 5,
    name: "Weight Management Capsules Combo Pack",
    category: "Weight Loss",
    price: 2499,
    originalPrice: 3208,
    rating: 4.8,
    reviews: 124,
    image: "/c3.png",
    gallery: [
      "/c1.jpeg",
      "/c2.jpeg"
    ],
    benefits: ["Metabolism Boost", "Natural Fat Burn", "Appetite Control"],
    description: "Powerful blend of natural herbs to support healthy weight management and boost metabolism",
    ingredients: ["Garcinia (Garcinia Gummi-Gutta) – 200 mg", "Green Tea (Camellia Sinensis) – 100 mg", "Green Coffee (Coffea Arabica / Coffea Canephora) – 100 mg", "Fenugreek (Trigonella Foenum Graecum) – 50 mg", "Guggul (Commiphora Mukul / Commiphoraspp) – 50 mg"],
    usage: "Take 2 capsules daily with meals or as directed by your healthcare practitioner.",
    size: "60 capsules (30-day supply)",
    inStock: true
  },
  
};

export default function ProductDetail() {
  const { id } = useParams<{ id: string }>();
  const productId = id || '';
  const product = products[parseInt(productId) as keyof typeof products];
  const { state, dispatch } = useCart();
  const [toast, setToast] = useState({ message: '', type: 'success' as const, isVisible: false });
  const [selectedImage, setSelectedImage] = useState(0);
  const [quantity, setQuantity] = useState(1);
  const [activeTab, setActiveTab] = useState('description');
  
  const isInCart = (productId: number) => {
    return state.items.some(item => item.id === productId);
  };

  // Add loading state
  if (!id) {
    return (
      <div className="min-h-screen bg-white">
        <Header />
        <div className="flex flex-col items-center justify-center h-96 text-center px-4">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-600 mb-4"></div>
          <h1 className="text-xl text-gray-900">Loading...</h1>
        </div>
        <Footer />
      </div>
    );
  }

  if (!product) {
    return (
      <div className="min-h-screen bg-white">
        <Header />
        <div className="flex flex-col items-center justify-center h-96 text-center px-4">
          <h1 className="text-3xl font-semibold text-gray-900 mb-4">Product Not Found</h1>
          <Link to="/products" className="bg-green-600 text-white px-6 py-3 rounded-full hover:bg-green-700 transition-colors">
            Browse All Products
          </Link>
        </div>
        <Footer />
      </div>
    );
  }

  const addToCart = () => {
    for (let i = 0; i < quantity; i++) {
      dispatch({ 
        type: 'ADD_TO_CART', 
        product: {
          id: product.id,
          name: product.name,
          price: product.price,
          image: product.image,
          category: product.category
        }
      });
    }
    setToast({
      message: `${quantity} ${product.name}${quantity > 1 ? 's' : ''} added to cart!`,
      type: 'success',
      isVisible: true
    });
  };

  const removeFromCart = () => {
    dispatch({
      type: 'REMOVE_FROM_CART',
      productId: product.id
    });
    setToast({
      message: `${product.name} removed from cart!`,
      type: 'success',
      isVisible: true
    });
  };

  const allImages = [product.image, ...product.gallery];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <main className="pt-6 sm:pt-8 pb-12 sm:pb-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <nav className="flex items-center space-x-2 text-xs sm:text-sm text-gray-600 mb-6 sm:mb-8">
            <Link to="/" className="hover:text-green-600">Home</Link>
            <i className="ri-arrow-right-s-line"></i>
            <Link to="/products" className="hover:text-green-600">Products</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-gray-900 truncate">{product.name}</span>
          </nav>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8 lg:gap-12 mb-12 sm:mb-16">
            <div>
              <div className="mb-4 sm:mb-6">
                <div className="w-full h-64 sm:h-80 lg:h-96 bg-gray-100 rounded-2xl shadow-lg flex items-center justify-center overflow-hidden">
                  <img 
                    src={allImages[selectedImage]} 
                    alt={product.name}
                    className="max-w-full max-h-full object-contain"
                  />
                </div>
              </div>
              <div className="flex space-x-3 sm:space-x-4 overflow-x-auto pb-2">
                {allImages.map((image, index) => (
                  <button
                    key={index}
                    onClick={() => setSelectedImage(index)}
                    className={`w-16 h-16 sm:w-20 sm:h-20 rounded-lg overflow-hidden border-2 transition-colors bg-gray-100 flex items-center justify-center flex-shrink-0 ${
                      selectedImage === index ? 'border-green-600' : 'border-gray-200'
                    }`}
                  >
                    <img src={image} alt="" className="max-w-full max-h-full object-contain" />
                  </button>
                ))}
              </div>
            </div>

            <div>
              <div className="mb-3 sm:mb-4">
                <span className="text-green-600 font-medium text-sm sm:text-base">{product.category}</span>
              </div>
              
              <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-3 sm:mb-4 leading-tight">{product.name}</h1>
              
              <div className="flex items-center mb-4 sm:mb-6">
                <div className="flex text-yellow-400 mr-2 sm:mr-3">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className={`ri-star-${i < Math.floor(product.rating) ? 'fill' : 'line'} text-base sm:text-lg`}></i>
                  ))}
                </div>
                <span className="text-gray-600 text-sm sm:text-base">
                  {product.rating} ({product.reviews} reviews)
                </span>
              </div>

              <div className="flex flex-col sm:flex-row sm:items-center space-y-2 sm:space-y-0 sm:space-x-4 mb-4 sm:mb-6">
                <span className="text-2xl sm:text-3xl font-bold text-green-600">₹{product.price}</span>
                <div className="flex items-center space-x-3">
                  <span className="text-lg sm:text-xl text-gray-500 line-through">₹{product.originalPrice}</span>
                  <span className="bg-green-100 text-green-800 px-2 sm:px-3 py-1 rounded-full text-xs sm:text-sm font-medium">
                    Save ₹{(product.originalPrice - product.price).toFixed(2)}
                  </span>
                </div>
              </div>

              <div className="mb-4 sm:mb-6">
                {product.benefits.map((benefit, index) => (
                  <span key={index} className="inline-block bg-green-100 text-green-800 text-xs sm:text-sm px-2 sm:px-3 py-1 rounded-full mr-2 mb-2">
                    {benefit}
                  </span>
                ))}
              </div>

              <div className="mb-4 sm:mb-6">
                <p className="text-gray-700 leading-relaxed text-sm sm:text-base">{product.description}</p>
              </div>

              <div className="flex flex-col sm:flex-row items-stretch sm:items-center space-y-3 sm:space-y-0 sm:space-x-4 mb-6 sm:mb-8">
                {!isInCart(product.id) && (
                  <div className="flex items-center border border-gray-300 rounded-lg w-fit mx-auto sm:mx-0">
                    <button
                      onClick={() => setQuantity(Math.max(1, quantity - 1))}
                      className="w-10 h-10 flex items-center justify-center hover:bg-gray-50"
                    >
                      <i className="ri-subtract-line"></i>
                    </button>
                    <span className="w-12 text-center font-medium">{quantity}</span>
                    <button
                      onClick={() => setQuantity(quantity + 1)}
                      className="w-10 h-10 flex items-center justify-center hover:bg-gray-50"
                    >
                      <i className="ri-add-line"></i>
                    </button>
                  </div>
                )}
                <button 
                  onClick={isInCart(product.id) ? removeFromCart : addToCart}
                  className={`flex-1 py-3 px-6 rounded-full font-semibold transition-colors text-center text-sm sm:text-base ${
                    isInCart(product.id)
                      ? 'bg-red-600 text-white hover:bg-red-700'
                      : 'bg-green-600 text-white hover:bg-green-700'
                  }`}
                >
                  {isInCart(product.id) 
                    ? 'Remove from Cart' 
                    : `Add to Cart - ₹${(product.price * quantity).toFixed(2)}`}
                </button>
              </div>

              <div className="space-y-2 sm:space-y-3 text-xs sm:text-sm text-gray-600">
                <div className="flex items-center space-x-2">
                  <i className="ri-truck-line text-green-600 flex-shrink-0"></i>
                  <span>All products available on Cash on Delivery</span>
                </div>
                <div className="flex items-center space-x-2">
                  <i className="ri-shield-check-line text-green-600 flex-shrink-0"></i>
                  <span>{product.inStock ? 'In stock' : 'Out of stock'}</span>
                </div>
                <div className="flex items-center space-x-2">
                  <i className="ri-refresh-line text-green-600 flex-shrink-0"></i>
                  <span>No online payment needed</span>
                </div>
              </div>
            </div>
          </div>

          <div className="border-t pt-12">
            <div className="flex space-x-8 mb-8">
              <button
                onClick={() => setActiveTab('description')}
                className={`pb-2 border-b-2 transition-colors ${
                  activeTab === 'description' 
                    ? 'border-green-600 text-green-600' 
                    : 'border-transparent text-gray-600 hover:text-gray-900'
                }`}
              >
                Description
              </button>
              <button
                onClick={() => setActiveTab('ingredients')}
                className={`pb-2 border-b-2 transition-colors ${
                  activeTab === 'ingredients' 
                    ? 'border-green-600 text-green-600' 
                    : 'border-transparent text-gray-600 hover:text-gray-900'
                }`}
              >
                Ingredients
              </button>
              <button
                onClick={() => setActiveTab('usage')}
                className={`pb-2 border-b-2 transition-colors ${
                  activeTab === 'usage' 
                    ? 'border-green-600 text-green-600' 
                    : 'border-transparent text-gray-600 hover:text-gray-900'
                }`}
              >
                How to Use
              </button>
            </div>

            <div className="bg-gray-50 rounded-2xl p-8">
              {activeTab === 'description' && (
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-4">Product Description</h3>
                  <p className="text-gray-700 leading-relaxed mb-4">{product.description}</p>
                  <p className="text-gray-700"><strong>Size:</strong> {product.size}</p>
                </div>
              )}
              
              {activeTab === 'ingredients' && (
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-4">Ingredients</h3>
                  <ul className="space-y-2">
                    {product.ingredients.map((ingredient, index) => (
                      <li key={index} className="flex items-center space-x-2">
                        <i className="ri-check-line text-green-600"></i>
                        <span className="text-gray-700">{ingredient}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
              
              {activeTab === 'usage' && (
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-4">How to Use</h3>
                  <p className="text-gray-700 leading-relaxed">{product.usage}</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </main>

      <Footer />
      
      <Toast
        message={toast.message}
        type={toast.type}
        isVisible={toast.isVisible}
        onClose={() => setToast(prev => ({ ...prev, isVisible: false }))}
      />
    </div>
  );
}